function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg114Bermuda(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3F3F3"
    },
    d: "M320,173.714v100.57c0,48.991,128,48.991,128,0v-100.57H320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6DA544"
    },
    d: "M320,274.286L320,274.286c0,48.989,64,64,64,64s64-15.01,64-64.001v0.001H320L320,274.286z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A2001D"
    },
    points: "384,234.057 354.286,246.857 354.286,274.286 384,292.571 413.715,274.286 413.715,246.857   "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.282,
    y: 219.425,
    style: {
      fill: "#338AF3"
    },
    width: 59.425,
    height: 27.429
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0,
    style: {
      fill: "#F0F0F0"
    },
    width: 256,
    height: 256
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "0,152.001 104.001,152.001 104.001,256.001 152.001,256.001 152.001,152.001 256,152.001   256,104.001 152.001,104.001 152.001,0.001 104.001,0.001 104.001,104.001 0,104.001 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "203.46,166.958 256,219.498 256,166.958  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "166.957,166.958 256,256.001 256,230.821 192.137,166.958  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "232.282,256.001 166.957,190.67 166.957,256.001  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "166.957,166.958 256,256.001 256,230.821 192.137,166.958 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "166.957,166.958 256,256.001 256,230.821 192.137,166.958 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "40.151,166.958 0,207.108 0,166.958  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "89.041,178.281 89.041,255.999 11.33,255.999  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "63.862,166.96 0,230.822 0,256.001 0,256.001 89.041,166.96 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "52.54,89.045 0,36.504 0,89.045  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "89.043,89.045 0,0.001 0,25.181 63.863,89.045  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "23.718,0.001 89.043,65.332 89.043,0.001  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "89.043,89.045 0,0.001 0,25.181 63.863,89.045 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "89.043,89.045 0,0.001 0,25.181 63.863,89.045 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "215.849,89.045 256,48.894 256,89.045  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "166.959,77.722 166.959,0.002 244.67,0.002  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "192.138,89.042 256,25.18 256,0.001 256,0.001 166.959,89.042 "
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg114Bermuda);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };